import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/Card';
import usePermissions from '../hooks/usePermissions';
import { PERMISSIONS } from '../services/permissions';
import { organizationsService } from '../services/organizationsService';
import FileUpload from './FileUpload';

/** Bulk uploads for the FastCube organization; needs the ``bulk.submit`` permission. */
const BulkUpload = () => {
  const { can } = usePermissions();
  const [hasFastCubeAccess, setHasFastCubeAccess] = useState(null);

  useEffect(() => {
    let cancelled = false;
    organizationsService
      .getOrganizations()
      .then((orgs) => !cancelled && setHasFastCubeAccess(organizationsService.hasFastCubeAccess(orgs)))
      .catch(() => !cancelled && setHasFastCubeAccess(false));
    return () => {
      cancelled = true;
    };
  }, []);

  if (!can(PERMISSIONS.BULK_SUBMIT)) return <Navigate to="/dashboard" replace />;
  if (hasFastCubeAccess === null) {
    return (
      <Card>
        <CardContent className="pt-6">
          <p className="text-sm text-gray-500">Loading…</p>
        </CardContent>
      </Card>
    );
  }
  if (!hasFastCubeAccess) return <Navigate to="/dashboard" replace />;

  return <FileUpload bulkOnly />;
};

export default BulkUpload;
